/* eslint-disable no-lonely-if */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { HelpRailViewId } from '@bingads-webui-react/help-rail-view-id';
import { FilterService } from '@bingads-webui/filter-service';
import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';
import { getFilterConfig } from './filter/filter-config';
import { FilterAgentManager } from './filter/filter-agent-manager';
import { SingleViewWrapper } from './common/view/single-view-wrapper';
import ProductGroupInlineChartWrapper from './common/view/product-group-inline-chart-wrapper';
import { getUpperToolbar } from './common/view/upper-toolbar';
import { ProductGroupFooter } from './common/view/product-group-tab-footer';
import { productGroupLevel } from './constant';
import ClientLogger from './log/client-logger';
import ProductGroupTreeGrid from './tree-view/tree-product-groups-grid';
import ProductGroupFlattenGrid from './flatten-view/flatten-product-groups-grid';
import { createProductGroupsGridFromNewPackage } from './grid-factory';

export class ProductGroup extends React.Component {
  static defaultProps = {
    campaign: undefined,
    adgroup: undefined,
  }

  static propTypes = {
    deps: PropTypes.objectOf(PropTypes.any).isRequired,
    campaign: PropTypes.objectOf(PropTypes.any),
    adgroup: PropTypes.objectOf(PropTypes.any),
    treeGridParameters: PropTypes.objectOf(PropTypes.any).isRequired,
    flattenGridParameters: PropTypes.objectOf(PropTypes.any).isRequired,
    isTreeView: PropTypes.bool.isRequired,
    preferenceConfig: PropTypes.objectOf(PropTypes.any).isRequired,
  }

  constructor(props) {
    super(props);

    this.learnMoreLinkText = this.props.deps.flattenView.i18n.getString('ProductGroupsGrid_LearnMore');
    this.refreshLinkText = this.props.deps.flattenView.i18n.getString('ProductGroupsGrid_RefreshLinkText');
    this.filterredInTreeView = false;
    this.state = {
      isTreeView: this.props.isTreeView,
      hasFilter: false,
      showToolbar: true,
      showMessageBar: false,
      showPopupMessage: false,
    };
    this.initializeFilterService();
    this.FilterAgentManager = new FilterAgentManager();
    this.upperToolbar = getUpperToolbar();
    this.needSync = false;
    this.FilterAgentManager.initializeFilterAgent({
      tabView: this,
      filterConfig: getFilterConfig(
        this.props.deps.flattenView,
        this.getLevel(), this.getBidOption()
      ),
      filterService: this.filterService,
      toolbar: this.upperToolbar,
    });
    this.logger = new ClientLogger(this.props.deps.treeView.instrumentation);
  }

  getBidOption() {
    const setting = this.props.adgroup ? _.first(this.props.adgroup.Settings) : {};
    // Default BidOption is BidValue
    return _.result(setting, 'BidOption', 0);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filterBar && !this.state.filterBar) {
      prevState.filterBar.remove();
    }
    if (prevState.filterEditor && !this.state.filterEditor) {
      prevState.filterEditor.remove();
    }
  }

  componentWillUnmount() {
    if (this.flattenGrid) {
      this.flattenGrid.remove();
    }
    if (this.treeGrid) {
      this.treeGrid.remove();
    }
  }

  onTogglePillClicked = (index) => {
    if ((this.state.isTreeView || this.state.hasFilter) && index === 0) {
      return;
    }
    if (!this.state.isTreeView && index === 1) {
      return;
    }

    this.needChangeSelectedColumns = !_.isUndefined(this.changedColumns);
    this.logger.logToggleGrid({ isTreeView: this.state.isTreeView });
    switch (index) {
      case 0:
        this.switchToTreeViewByRouter();
        break;
      case 1:
        this.switchToFlattenViewByRouter();
        break;
      default:
        break;
    }
  }

  onMessageBar = (message) => {
    this.setState({
      showMessageBar: true,
      showPopupMessage: false,
      showTooMuchProductOffer: false,
      message,
    });
  }

  onShowTooMuchProductOffer = (tooMuchProductOfferMessage) => {
    this.setState({
      showTooMuchProductOffer: true,
      showMessageBar: false,
      showPopupMessage: false,
      tooMuchProductOfferMessage,
    });
  }

  onPopupMessage = (popupMessage) => {
    this.setState({
      showMessageBar: false,
      showPopupMessage: true,
      showTooMuchProductOffer: false,
      popupMessage,
    });
  }

  renderFilterAgentView = () => (
    <div>
      {this.state.filterBar &&
        <BackboneInstanceWrapper instance={this.state.filterBar} managed />}
      {this.state.filterEditor &&
        <BackboneInstanceWrapper instance={this.state.filterEditor} managed />}
    </div>
  )

  updateViewWithFilter = (filter) => {
    this.logger.logApplyFilter({
      filter,
      level: this.getLevel(),
      isTreeView: this.state.isTreeView,
    });
    if (this.flattenGrid) {
      updateGridQuery(this.flattenGrid.grid.gridView, filter);
    } else {
      // if flattenGrid does not exist, then save this filter in the parameter
      // and apply it after flattenGrid is created.
      this.currentGridFilter = filter;
    }
    this.setState({
      hasFilter: filter.depth !== 0,
    });
  }

  onColumnChooserMenuChanged = (isTreeGrid) => {
    if (isTreeGrid && this.flattenGrid) {
      this.flattenGrid.refreshColumnChooserMenu();
    }
    if (!isTreeGrid && this.treeGrid) {
      this.treeGrid.refreshColumnChooserMenu();
    }
  }

  onSelectedColumnsChanged = (names) => {
    this.logger.logChangeSelectedColumn({
      columns: names,
      level: this.getLevel(),
      isTreeView: this.state.isTreeView,
    });
    if (this.flattenGrid && this.treeGrid) {
      this.changedColumns = names;
    }
  }

  generateGrid = () => {
    const callbacks = {
      onMessageBar: this.onMessageBar,
      onPopupMessage: this.onPopupMessage,
      onTogglePillClicked: this.onTogglePillClicked,
      markNeedSync: this.markNeedSync,
      onColumnChooserMenuChanged: this.onColumnChooserMenuChanged,
      onSelectedColumnsChanged: this.onSelectedColumnsChanged,
      onShowTooMuchProductOffer: this.onShowTooMuchProductOffer,
    };

    if (this.state.isTreeView) {
      if (!this.treeGrid) {
        if (this.props.deps.treeView.pageContext.Permissions.IsConsumeProductGroupsGridInOldUIProductGroupsTabEnabled) { // eslint-disable-line
          this.treeGrid = createProductGroupsGridFromNewPackage({
            campaign: this.props.campaign,
            adgroup: this.props.adgroup,
            level: productGroupLevel.AdGroup,
            gridParameters: this.props.treeGridParameters,
            callbacks,
            filterService: this.filterService,
            isTreeView: true,
            preferenceConfig: this.props.preferenceConfig,
          });
        } else {
          this.treeGrid = new ProductGroupTreeGrid({
            deps: this.props.deps.treeView,
            campaign: this.props.campaign,
            adgroup: this.props.adgroup,
            filterService: this.filterService,
            level: productGroupLevel.AdGroup,
            gridParameters: this.props.treeGridParameters,
            callbacks,
            preferenceConfig: this.props.preferenceConfig,
          });
        }
        this.treeGridToolbar = new SingleViewWrapper({
          view: this.treeGrid.getToolBar(),
          rendered: true,
        });
      }
    } else {
      if (!this.flattenGrid) {
        if (this.props.deps.treeView.pageContext.Permissions.IsConsumeProductGroupsGridInOldUIProductGroupsTabEnabled) { // eslint-disable-line
          this.flattenGrid = createProductGroupsGridFromNewPackage({
            campaign: this.props.campaign,
            adgroup: this.props.adgroup,
            level: this.getLevel(),
            gridParameters: this.props.flattenGridParameters,
            callbacks,
            filterService: this.filterService,
            isTreeView: false,
            preferenceConfig: this.props.preferenceConfig,
          });
        } else {
          this.flattenGrid = new ProductGroupFlattenGrid({
            deps: this.props.deps.flattenView,
            campaign: this.props.campaign,
            adgroup: this.props.adgroup,
            filterService: this.filterService,
            level: this.getLevel(),
            gridParameters: this.props.flattenGridParameters,
            callbacks,
            preferenceConfig: this.props.preferenceConfig,
          });
        }
        if (this.currentGridFilter) {
          updateGridQuery(this.flattenGrid.grid.gridView, this.currentGridFilter);
        }
        this.flattenGridToolbar = new SingleViewWrapper({
          view: this.flattenGrid.getToolBar(),
          rendered: true,
        });
      }
    }
  }

  getLevel = () => {
    if (_.isUndefined(this.props.campaign)) {
      return productGroupLevel.Account;
    } else if (_.isUndefined(this.props.adgroup)) {
      return productGroupLevel.Campaign;
    }
    return productGroupLevel.AdGroup;
  }

  renderToolbar = () => {
    if (!this.state.isTreeView && this.state.hasFilter
      && this.getLevel() === productGroupLevel.AdGroup) {
      this.flattenGridToolbar.view.update({
        id: 'view-toggle',
        classes: 'disabled',
        onClick: this.onDisabledTogglePillClicked,
      });
    }

    if (!this.state.isTreeView && !this.state.hasFilter
      && this.getLevel() === productGroupLevel.AdGroup) {
      this.flattenGridToolbar.view.update({
        id: 'view-toggle',
        classes: '',
        onClick: this.onTogglePillClicked,
      });
    }

    if (this.state.showToolbar) {
      return this.state.isTreeView ?
        <BackboneInstanceWrapper instance={this.treeGridToolbar} managed /> :
        <BackboneInstanceWrapper instance={this.flattenGridToolbar} managed />;
    }
    return null;
  }

  renderGrid = () => {
    const gridView = this.state.isTreeView ? this.treeGrid : this.flattenGrid;
    const className = this.state.isTreeView ? 'tree-grid' : 'flatten-grid';
    if (this.needRefresh) {
      gridView.refreshGrid();
      this.needRefresh = false;
    }
    if (this.needChangeSelectedColumns) {
      gridView.updateSelectedColumns(this.changedColumns);
      this.changedColumns = undefined;
      this.needChangeSelectedColumns = false;
    }
    return (
      <div className={className}>
        <BackboneInstanceWrapper instance={gridView} managed />
      </div>
    );
  }

  renderMessageBar = () =>
    (this.state.showMessageBar ? (
      <div className="alert alert-info">
        <span className="glyph-info product-groups-glyph" />
        <span className="product-groups-message">
          {this.state.message}
        </span>
        <button id="HelpTopic" className="HelpTopic product-groups-link btn-link learn-more" query="app54694">
          {this.learnMoreLinkText}
        </button>
        <span className="glyphicon glyphicon-remove product-groups-glyph product-groups-x-button" onClick={() => { this.setState({ showMessageBar: false }); }} role="button" />
      </div>
    ) : undefined);

  renderTooMuchProductOfferBar = () => (this.state.showTooMuchProductOffer ? (
    <div className="alert alert-warning">
      <span className="glyph-info product-groups-glyph" />
      <span className="product-groups-message">
        {this.state.tooMuchProductOfferMessage}
      </span>
    </div>
  ) : null);

  renderPopupMessage = () =>
    (this.state.showPopupMessage ? (
      <div className="product-groups-popup alert alert-warning">
        <span className="alert-icon warning product-groups-glyph" />
        <span className="product-groups-message">
          {this.state.popupMessage}
        </span>
        <a className="product-groups-link" onClick={this.refreshGrid} role="button" >{this.refreshLinkText}</a>
        <span className="glyphicon glyphicon-remove product-groups-glyph product-groups-x-button" onClick={() => { this.setState({ showPopupMessage: false }); }} role="button" />
      </div>
    ) : undefined);

  renderInlineChart = () => (
    <ProductGroupInlineChartWrapper
      deps={this.props.deps.treeView}
      upperToolbar={this.upperToolbar}
      hasFilter={this.state.hasFilter}
    />
  );

  renderUpperToolbar = () => {
    if (this.state.showToolbar) {
      return <BackboneInstanceWrapper instance={this.upperToolbar} managed />;
    }
    return null;
  }

  markNeedSync = () => {
    this.needSync = true;
  }

  markFilterredInTreeView = () => {
    this.filterredInTreeView = true;
  }

  markFilterredInFlattenView = () => {
    this.filterredInTreeView = false;
  }

  initializeFilterService = () => {
    this.filterService = new FilterService(getFilterConfig(
      this.props.deps.flattenView,
      this.getLevel(),
      this.getBidOption()
    ));
    this.filterService.p$Initialized.then(() => {
      const filter = this.filterService.getCombinedFilter();
      if (filter.depth !== 0) {
        this.updateViewWithFilter(filter);
      }
    });
  }

  checkShouldRefresh = () => {
    this.needRefresh = this.needSync;
    this.needSync = false;
  }

  switchToFlattenViewByRouter = () => {
    // There is a bug in Router, that is, if the navigate() is invoked more than one time
    // sequentially, navigate() won't work later.
    // The way to work around here is to judge whether window.App.router_new.$target_state exists.
    // If it exists, it means that there already has a navigate() call which doesn't finish yet.
    if (!window.App.router_new.$target_state) {
      this.checkShouldRefresh();
      window.App.navigate('customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/productgroups/flatten');
    }
  }

  switchToTreeViewByRouter = () => {
    if (!window.App.router_new.$target_state) {
      this.checkShouldRefresh();
      window.App.navigate('customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/productgroups');
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.hasFilter && nextState.isTreeView) {
      this.markFilterredInTreeView();
      this.switchToFlattenViewByRouter();
      return false;
    }
    if (!nextState.hasFilter && !nextState.isTreeView && this.filterredInTreeView) {
      this.filterredInTreeView = false;
      this.switchToTreeViewByRouter();
      return false;
    }
    return true;
  }

  refreshGrid = () => {
    this.setState({
      showPopupMessage: false,
    }, () => {
      const currentGrid = this.state.isTreeView ? this.treeGrid : this.flattenGrid;
      currentGrid.refreshGrid();
    });
  }

  renderNoDataContainer = () => (
    <div className="grid-nodata-container" />
  );

  renderFooter = () => (
    <ProductGroupFooter
      appendLearnMoreLink={this.props.deps.flattenView.appendLearnMoreLink}
      i18n={this.props.deps.flattenView.i18n}
      accountTimeZoneText={this.props.deps.flattenView.getTimeZoneForDateRangeText()}
    />
  )

  render() {
    this.generateGrid();
    return (
      <div className="product-groups">
        <div className="bingadsgrid">
          <HelpRailViewId railViewId="productgroups_load" />
          {this.renderUpperToolbar()}
          {this.renderFilterAgentView()}
          {this.renderInlineChart()}
          {this.renderMessageBar()}
          {this.renderTooMuchProductOfferBar()}
          {this.renderToolbar()}
          {this.renderGrid()}
          {this.renderNoDataContainer()}
          {this.renderPopupMessage()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}
